var jwtHelper = (function(){

    var jwtHelperObject = {};
    var timer;

    jwtHelperObject.isRefreshCallRequired = function(timeToken){
        var toReturn = false;
        toReturn = ((timeToken*1000) - (new Date().getTime())   <= (30 * 1000)) ;
        return toReturn;
    };

    jwtHelperObject.getJWTExpiryTime = function(token){
        var tokenInformation = jwtHelperObject.parseCookie(token);
        var current = new Date();
        // for the system logging out early the refresh time is now token expiry time/2 - 30 sec
        //to call before 30 seconds of the token expiry.
        var difference =  ((tokenInformation.exp * 1000) - current.getTime())/2 - (30*1000) ;
        return {interval:difference,tokenTime:tokenInformation.exp};
    }

    jwtHelperObject.initiateTimer = function(interval,callBack){
        var diffMilliseconds =  interval ;
        clearTimeout(timer);
        timer = window.setTimeout(function(){
            callBack.apply();

        },diffMilliseconds);
    }

    jwtHelperObject.parseCookie = function(token){
        return JSON.parse(atob(token.split('.')[1]));
    }

    jwtHelperObject.updateToken = function(inputToken){
        token = inputToken;
    }

    return jwtHelperObject;
})();
